<template>
  <div class="automacao-editor__variavel-wrap">
    <button
      type="button"
      class="automacao-editor__variavel-abrir"
      :class="{ 'is-aberto': aberto }"
      @click.stop="alternar"
    >
      <i class="fas fa-plus" aria-hidden="true"></i>
      Inserir variável
    </button>
    <div v-if="aberto" class="automacao-editor__variavel-balao" @click.stop>
      <input
        ref="busca"
        class="form-control form-control-sm"
        type="search"
        placeholder="Pesquisar variável"
        :value="busca"
        @input="busca = $event.target.value"
      >
      <div class="automacao-editor__variavel-lista">
        <p v-if="!grupos.length" class="automacao-editor__variavel-vazio">Nenhuma variável</p>
        <div v-for="grupo in grupos" :key="grupo.titulo" class="automacao-editor__variavel-grupo">
          <p>{{ grupo.titulo }}</p>
          <button
            v-for="item in grupo.itens"
            :key="item.chave"
            type="button"
            class="automacao-editor__variavel-item"
            :title="tituloItem(item)"
            @click="escolher(item.chave)"
          >
            <span>{{ item.rotulo }}</span>
            <small>{{ tokenItem(item.chave) }}</small>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutomacaoVariavelPicker',
  props: {
    fixas: {
      type: Array,
      default: function () {
        return []
      },
    },
    campos: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data: function () {
    return {
      aberto: false,
      busca: '',
    }
  },
  computed: {
    grupos() {
      const termo = this.normalizar(this.busca)
      const filtrar = (lista) =>
        (lista || []).filter((item) => {
          if (!termo) {
            return true
          }
          return (
            this.normalizar(item.rotulo).indexOf(termo) !== -1 ||
            this.normalizar(item.chave).indexOf(termo) !== -1
          )
        })
      const grupos = []
      const oportunidade = filtrar(this.fixas)
      if (oportunidade.length) {
        grupos.push({ titulo: 'Oportunidade', itens: oportunidade })
      }
      const customizados = filtrar(this.campos)
      if (customizados.length) {
        grupos.push({ titulo: 'Campos customizados', itens: customizados })
      }

      return grupos
    },
  },
  watch: {
    aberto: function (aberto) {
      if (!aberto) {
        this.busca = ''
        return
      }
      this.$nextTick(() => {
        if (this.$refs.busca) {
          this.$refs.busca.focus()
        }
      })
    },
  },
  mounted() {
    document.addEventListener('click', this.fecharFora)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.fecharFora)
  },
  methods: {
    normalizar(valor) {
      return String(valor || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },
    alternar() {
      this.aberto = !this.aberto
    },
    fecharFora(evento) {
      if (!this.aberto || !this.$el || this.$el.contains(evento.target)) {
        return
      }
      this.aberto = false
    },
    escolher(chave) {
      this.aberto = false
      this.$emit('inserir', chave)
    },
    tokenItem(chave) {
      return '{{' + chave + '}}'
    },
    tituloItem(item) {
      return item.rotulo + ' — ' + this.tokenItem(item.chave)
    },
  },
}
</script>
